/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Read_MoreInputs */

const en_notes_read_more = /** @type {(inputs: Notes_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

const pt_br2_notes_read_more = /** @type {(inputs: Notes_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ler mais`)
};

/**
* | output |
* | --- |
* | "Read more" |
*
* @param {Notes_Read_MoreInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_read_more = /** @type {((inputs?: Notes_Read_MoreInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Read_MoreInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_read_more(inputs)
	return pt_br2_notes_read_more(inputs)
});